import { useState } from 'react';
import '../App.css';
// import '../js/bus.js';
import Rebus from '../json/data.json';

export default function Bus(){

    let stopArr = [], stopName=[], stopId=[], roadImg=[];
    Rebus.BUSSTOP.map( (stop,k) => ( stopArr.push(stop['stopImg']) )) //버스정류장 이미지
    Rebus.BUSSTOP.map( (stop,k) => ( stopName.push(stop['stop']))) // 버스정류장 이름
    Rebus.BUSSTOP.map( (stop,k) => ( stopId.push(stop['stopID']))) // 버스정류장 id
    Rebus.BUSSTOP.map( (stop,k) => ( roadImg.push(stop['roadImg']))) // roadImg

    let [stop,stopChange] = useState(0) // 버스정류장 이미지
    let [page, pageChange] = useState(1) //페이지넘버
    let [sName, sNameC] = useState(0) // 정류장 이름
    let [id, idC] = useState(0) // 정류장id
    let [road, roadC] = useState(0) // 로드이미지

    function next(){
        if(stop<stopArr.length -1){
            stopChange(stop+1)
            pageChange(page+1)
            sNameC(sName+1)
        }else{
            stopChange(0)
            pageChange(1)
            sNameC(0)
        }
    }
    function prev(){
        stopChange(stop-1)
        pageChange(page-1)
        sNameC(sName-1)
        if( page == 1 ){
            stopChange(8)
            pageChange(9)
            sNameC(8)
        }
    }
    const pop = document.querySelector('.pop')
    // function popup(){
    //     pop.classList.add('active')
    // }

    function roadNext(){
        if(sName == 8) return;
        sNameC(sName+1)
        idC(id+1)
        roadC(road+1)
        pageChange(page+1)
        stopChange(stop+1)
    }
    function roadPrev(){
        if(sName == 0) return;
        sNameC(sName-1)
        idC(id-1)
        roadC(road-1)
        pageChange(page-1)
        stopChange(stop-1)
    }
    function stoppop(){
        pop.style.display = 'block'
    }
    function closepop(){
        pop.style.display = 'none'
    }

    let hoverImg = [], busImg=[];
    Rebus.BUS.map( (img,k) => ( hoverImg.push( img['hover']) ))
    Rebus.BUS.map( (img,k) => ( busImg.push( img['img']) ))
    
    return(
        <>
            <div className="busIntro">
                <figure><img src={require("../img/regreenbus_intro_logo.png").default} alt=""/></figure>
                <h2>칠성사이다, <b>청량한 세상</b>을 만들다</h2>
                <div><img src={require("../img/regreenbus_intro_logo_bus.png").default} alt=""/></div>
                <iframe width="763" height="430" src="https://www.youtube.com/embed/HkRKW2f1hPU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <p>미세먼지를 비롯한 각종 대기오염 물질로부터 노출되는 삭막한 도심 속 버스정류장을<br/>식물 녹화로 자연 친화적인 청량한 버스정류장으로 탈바꿈시켜, 맑고 깨끗한 녹색쉼터로 조성했습니다.<br/>누구에게나 초록 휴식이 되는 버스정류장. 칠성사이다가 서울시와 함께 만듭니다.</p>
            </div>
            <div className="busStop">
                <div className="busStopTit">
                    <article>
                        <h2><b>RE:GREEN</b> 버스정류장이란?</h2>
                        <p>상록기린초, 수호초 등 다양한 식물들과 식물의 잎, 뿌리, 탄소필터를 통한<br/> 친환경 공기정화시스템(바이오 월)이 만드는 청량한 공기를 맡으며 바쁜 일상 속의 초록 휴식을 누려보세요</p>
                    </article>
                    <p><img src={require("../img/regreenbus_info_img.png").default} alt=""/></p>
                </div>
                <div className="busImg">
                    <p><img src={require("../img/regreenbus_info_bg.png").default} alt=""/></p>
                    {
                        Rebus.BUS.map( (re,k) => (
                            <div key={k}>
                                <img src={ require(`../img/${hoverImg[k]}`).default} alt="" className={re['hoverName']}/>
                                <img src={ require(`../img/${busImg[k]}`).default} alt="" className={re['imgName']}/>
                                <button className={re['btnName']}>+</button>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="adCopy">
                <div className="adTit">
                    <h2><b>칠성사이다</b> 광고 카피 공모전 당선작을 만나보세요</h2>
                    <p>합정역부터 아현역에 이르는 양화 • 신촌로(6.2km) Green Road가<br/>여러분들이 직접 작성한 사이다 광고 카피로 다시 태어났습니다.</p>
                    <div>지도의 버스정류장&nbsp;&nbsp;<button>+</button>&nbsp;&nbsp;버튼을 클릭하시면, 광고카피 당선작을 보실 수 있습니다.</div>
                </div>
                <div className="adBus">
                    <p><img src={require("../img/regreenbus_road_img.jpg").default} alt=""/></p>
                    <div className="adBtn">
                        {
                            Rebus.BUSSTOP.map( (sb,k) => (
                                <p className={sb['stopName']} key={k}>
                                    <button onClick={stoppop}>+</button>
                                </p>
                            ))
                        }
                    </div>
                </div>
                <div className="adSlide">
                    <p><span></span><span></span><span></span><span></span><span></span></p>
                    <div><img src={require(`../img/${stopArr[stop]}`).default} alt=""/></div>
                    <p className="sltit">{stopName[sName]}</p>
                </div>
                <p className="stopBtn">
                    <button onClick={prev}></button>
                    <strong>{page} / 9</strong>
                    <button onClick={next}></button>
                </p>
                <div className="pop">
                    <div>
                        <p className="poptit">
                            <button onClick={roadPrev}></button>
                            <span>
                                <div>{stopName[sName]}</div>
                                <p>{stopId[id]}</p>
                            </span>
                            <button onClick={roadNext}></button>
                        </p>
                        <div className="popimg">
                            <p><img src={ require(`../img/${roadImg[road]}`).default } alt="" onClick={closepop}/></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}